import { CORVA_API_URLS } from './constants';

/**
 * @param {string=} path
 * @returns {string}
 */
export function getApiUrl(path = '') {
  return new URL(path, CORVA_API_URLS.API).href;
}

/**
 * @param {string=} path
 * @returns {string}
 */
export function getDataApiUrl(path = '') {
  return new URL(path, CORVA_API_URLS.DATA_API).href;
}
